<template>
  <div id="app" :class="clientClass">
    <main>
      <router-view v-if="show_game" :name="userStatusRoute" />
      <BpErrorPopup v-if="getError" :errorData="getError" />
      <MycomPaymentFrame ref="mycom_payment_frame" :frameType="getBillingPopupType" />
      <Notifications />
      <Counters />
    </main>
  </div>
</template>
<script>
import "./assets/global/styles/index.styl";

import Counters from "@libs/counters/projects/wf/Counters.vue";
import BpErrorPopup from "@/components/Errors/Error.vue";
import MycomPaymentFrame from "./components/Common/MycomPaymentFrame";
import { lang } from "@libs/translate/translate";
import auth_service_config from "./config/auth_service_config";
import { mapGetters } from "vuex";
import Notifications from "@libs/notifications/projects/wf/Notifications.vue";

export default {
  name: "App",
  components: {
    Counters,
    BpErrorPopup,
    MycomPaymentFrame,
    Notifications,
  },
  data() {
    return {
      //TODO: set to false
      show_game: false,
    };
  },
  computed: {
    ...mapGetters("global", ["getUserBpStatus", "isClient", "isClosed"]),
    getError() {
      return this.$store.state.server_error.data;
    },
    userStatusRoute() {
      //TODO: uncomment
      // return "guest";
      if (this.isClosed) return "closed";
      return this.getUserBpStatus ? this.getUserBpStatus : "guest";
    },
    clientClass() {
      return { "client-side": this.isClient };
    },
    getBillingPopupType() {
      return this.getUserBpStatus === "member" ? "points" : "premium";
    },
  },
  created() {
    this.$store.commit("global/writeCurrentLanguage", lang);
    this.setupAuthService();
  },
  mounted() {
    //TODO: uncomment
    this.getAppInfo();
    this.checkUrl();
  },
  methods: {
    setupAuthService() {
      this.$auth_service.setConfig(auth_service_config);
      this.$auth_service.loadKit();
    },
    checkUrl() {
      let ret = {};

      location.search.substr(1).replace(/([^=&]+)=([^&]*)/g, function(o, k, v) {
        ret[k] = v;
      });

      if (ret["client"]) {
        this.$store.commit("global/writeIsClient");
      }
    },
    getAppInfo() {
      this.$store.dispatch("global/appStartInit").then(() => {
        let event = new Event("event::loadingStop");
        this.show_game = true;
        document.dispatchEvent(event);
      });
    },
  },
};
</script>
